import { CalendarOutlined, TableOutlined, SearchOutlined, DollarOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { t } from "i18next";
import { useSearch } from "../../../context/SearchContext";

const NAV_HEIGHT = 60;
const ACCENT = '#1890ff';
const INACTIVE = '#8c8c8c';

function NavItem({ icon, label, active, onClick }) {
    return (
        <div
            onClick={onClick}
            style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 2,
                color: active ? ACCENT : INACTIVE,
                cursor: 'pointer',
                padding: '6px 4px',
                userSelect: 'none',
                WebkitTapHighlightColor: 'transparent',
            }}
        >
            <span style={{ fontSize: 20, lineHeight: 1 }}>{icon}</span>
            <span style={{ fontSize: 11, lineHeight: 1.2 }}>{label}</span>
        </div>
    );
}

function MergedFabHalf({ icon, color, ariaLabel, onClick, position }) {
    return (
        <button
            type="button"
            onClick={onClick}
            aria-label={ariaLabel}
            style={{
                width: 56,
                height: 52,
                border: 'none',
                background: color,
                color: '#fff',
                fontSize: 20,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                WebkitTapHighlightColor: 'transparent',
                transition: 'filter 120ms ease',
                padding: 0,
                // Hangi yarımsa o tarafa yuvarlatılır
                borderTopLeftRadius: position === 'left' ? 26 : 0,
                borderBottomLeftRadius: position === 'left' ? 26 : 0,
                borderTopRightRadius: position === 'right' ? 26 : 0,
                borderBottomRightRadius: position === 'right' ? 26 : 0,
                // İki yarım arasında ince beyaz ayırıcı
                borderLeft: position === 'right' ? '1px solid rgba(255,255,255,0.35)' : undefined,
            }}
            onTouchStart={(e) => { e.currentTarget.style.filter = 'brightness(0.9)'; }}
            onTouchEnd={(e) => { e.currentTarget.style.filter = ''; }}
        >
            {icon}
        </button>
    );
}

export default function BottomNav({ onOpenQuote }) {
    const history = useHistory();
    const { openSearch } = useSearch();
    const path = window.location.pathname;

    const isCalendar = path.includes('/appointments/calendar');
    const isAppointments = path.includes('/appointments/grid') || /\/appointments\/\d+/.test(path);

    return (
        <nav
            style={{
                position: 'fixed',
                left: 0,
                right: 0,
                bottom: 0,
                height: NAV_HEIGHT,
                backgroundColor: '#fff',
                borderTop: '1px solid #f0f0f0',
                boxShadow: '0 -2px 12px rgba(0,0,0,0.08)',
                display: 'flex',
                alignItems: 'stretch',
                zIndex: 99,
                paddingBottom: 'env(safe-area-inset-bottom, 0px)',
            }}
        >
            <NavItem
                icon={<CalendarOutlined />}
                label={t('Calendar')}
                active={isCalendar}
                onClick={() => history.push('/app/appointments/calendar')}
            />
            {/* Center: Search + Teklif merge edilmiş tek pill FAB */}
            <div style={{
                flex: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-start',
            }}>
                <div style={{
                    display: 'flex',
                    marginTop: -20,
                    borderRadius: 28,
                    overflow: 'hidden',
                    boxShadow: '0 4px 14px rgba(82,196,26,0.40), 0 2px 4px rgba(0,0,0,0.1)',
                }}>
                    <MergedFabHalf
                        icon={<DollarOutlined />}
                        color="#52c41a"
                        ariaLabel="Fiyat Teklifi"
                        onClick={onOpenQuote}
                        position="left"
                    />
                    <MergedFabHalf
                        icon={<SearchOutlined />}
                        color={ACCENT}
                        ariaLabel={t('Search')}
                        onClick={openSearch}
                        position="right"
                    />
                </div>
            </div>
            <NavItem
                icon={<TableOutlined />}
                label={t('Appointments')}
                active={isAppointments}
                onClick={() => history.push('/app/appointments/grid')}
            />
        </nav>
    );
}

export { NAV_HEIGHT as BOTTOM_NAV_HEIGHT };
